import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteEditListPayload } from '@app-store/slices/editList/delete'

interface TaskAction extends Action {
    payload: IDeleteEditListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.editList.delete

function* deleteEditListSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/companies/edit-lists/${payload.data.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Assigned list deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteEditListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteEditListSagaTask)
}

export default deleteEditListSaga
